module.exports = __webpack_public_path__ + "static/media/loading-gif.625cc59d.webp";